type AppInsightsNoop = {
    trackEvent: (..._args: unknown[]) => void;
    trackException: (..._args: unknown[]) => void;
    trackMetric: (..._args: unknown[]) => void;
    setAuthenticatedUserContext: (..._args: unknown[]) => void;
    clearAuthenticatedUserContext: (..._args: unknown[]) => void;
};

const noop = () => {};

// Telemetry intentionally disabled (no external calls).
const appInsights: AppInsightsNoop = {
    trackEvent: noop,
    trackException: noop,
    trackMetric: noop,
    setAuthenticatedUserContext: noop,
    clearAuthenticatedUserContext: noop,
};

export {appInsights};
